export const GET_LIST_THONGKETHU = "GET_LIST_THONGKETHU";
export const GET_LIST_THONGKETHU_SUCCESS = "GET_LIST_THONGKETHU_SUCCESS";
export const GET_LIST_THONGKETHU_FAILURE = "GET_LIST_THONGKETHU_FAILURE";
